/* eslint-disable @typescript-eslint/no-explicit-any*/
// надо что то придумать с any в этом файле
import {API} from "@/api/generated";
import {HTTP, BASEURL} from "../../http";
import {useQuizStore} from "@/stores/quizData";

const MEDIA_UPLOAD_TIMEOUT_MS = 300000;
const INTERNAL_READDS_HOSTS = new Set(["ya.readds.ru", "reserve.readds.ru"]);

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);
const PUBLIC_READDS_HOSTS = new Set(["beta.readds.ru"]);

function getCurrentQuizHost(): string {
  const currentHost = window.location.host;
  const currentHostname = window.location.hostname;

  if (LOCAL_HOSTS.has(currentHostname)) {
    return currentHost;
  }

  if (PUBLIC_READDS_HOSTS.has(currentHostname)) {
    return currentHostname;
  }

  return "readds.ru";
}

function normalizePublicQuizBaseUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);

    if (INTERNAL_READDS_HOSTS.has(parsedUrl.hostname)) {
      parsedUrl.host = getCurrentQuizHost();
    }

    parsedUrl.pathname = "/quiz/";
    parsedUrl.search = "";
    parsedUrl.hash = "";

    return parsedUrl.toString();
  } catch {
    const currentHost = getCurrentQuizHost();
    const protocol = LOCAL_HOSTS.has(window.location.hostname)
      ? "http"
      : "https";

    return `${protocol}://${currentHost}/quiz/`;
  }
}

export function modifyQuiz(
  action: string,
  numOrValue: any,
  keys: (string | number)[],
  notABtest = false
): any | void {
  const quizStore = useQuizStore();
  const target = numOrValue?.target;
  const originalQuiz = quizStore.getQuiz;
  const lk = document.location.pathname.includes("quiz/setting/");
  const isOriginalABTest =
    originalQuiz.nowReturn === "ABtest" && !lk && originalQuiz.ABTestBool;

  const isStoredABTest = localStorage.getItem("ABTest") === "true";
  const ABTest = (isOriginalABTest || isStoredABTest) && !notABtest;

  function isMobileVersion(val: boolean | string): boolean {
    return val === true || (val === "Мобильная" && !keys.includes("questions"));
  }

  const rawVersionText = quizStore.getSelectedVersion;
  const rawVersionBool = quizStore.getMobileVersion;
  const mobileVersion =
    isMobileVersion(rawVersionText) || isMobileVersion(rawVersionBool);

  const isTextContactButtonPath =
    keys.length === 1 && keys[0] === "textContactButton";

  const additionalKeys = [
    mobileVersion ? "mobileVersionQuiz" : "",
    ABTest ? "ABTestObj" : ""
  ].filter(Boolean);

  const fullPath = [...additionalKeys, ...keys];
  const lastKey = fullPath[fullPath.length - 1];
  const pathToObject = fullPath.slice(0, -1);

  numOrValue = target?.value ?? target?.innerHTML ?? numOrValue;

  if (action === "get") {
    if (isTextContactButtonPath) {
      return getTextContactButtonValue(originalQuiz, mobileVersion, ABTest);
    }

    let current = originalQuiz;
    for (const key of pathToObject) {
      if (!current || typeof current !== "object" || !(key in current)) {
        if (!notABtest) {
          return modifyQuiz(action, numOrValue, keys, true);
        }
        return undefined;
      }
      current = current[key];
    }

    const value = current ? current[lastKey] : undefined;
    if (value === undefined && !notABtest) {
      return modifyQuiz(action, numOrValue, keys, true);
    }

    if ((Array.isArray(value) || typeof value === "object") && !notABtest) {
      if (Array.isArray(value)) {
        return value;
      }
      let orig = modifyQuiz(action, numOrValue, keys, true);
      return copyIsOrigInAb(orig, value);
    }

    return value;
  }

  const quiz = JSON.parse(JSON.stringify(originalQuiz || {}));

  if (action === "set" && isTextContactButtonPath) {
    const textContactButtonTarget = getTextContactButtonTarget(
      quiz,
      mobileVersion,
      ABTest
    );

    if (textContactButtonTarget) {
      const key = mobileVersion ? "mobile" : "pc";
      textContactButtonTarget[key] = numOrValue;
      quizStore.setQuiz(quiz);
      return;
    }
  }

  let current = quiz;
  if (Array.isArray(current["ABTestObj"])) {
    current["ABTestObj"] = {};
  }
  for (const key of pathToObject) {
    if (typeof current[key] !== "object" || current[key] === null) {
      current[key] = {};
    }
    current = current[key];
  }

  switch (action) {
    case "push":
      if (!Array.isArray(current[lastKey])) current[lastKey] = [];
      current[lastKey].push(numOrValue);
      break;
    case "splice":
      if (typeof current[lastKey] === "object") {
        current[lastKey] = [...current[lastKey]];
      }
      if (Array.isArray(current[lastKey])) {
        current[lastKey].splice(numOrValue, 1);
      }
      break;
    case "set":
      current[lastKey] = numOrValue;
      break;
  }

  quizStore.setQuiz(quiz);
}

function isVersionedTextContactButton(
  value: any
): value is {pc?: string; mobile?: string} {
  return Boolean(value && typeof value === "object" && !Array.isArray(value));
}

function normalizeTextContactButton(
  value: any,
  mobileVersion: boolean
): string | undefined {
  if (typeof value === "string") {
    return value;
  }

  if (!isVersionedTextContactButton(value)) {
    return undefined;
  }

  const currentVersionValue = mobileVersion ? value.mobile : value.pc;
  const fallbackValue = mobileVersion ? value.pc : value.mobile;

  return currentVersionValue ?? fallbackValue;
}

function getTextContactButtonValue(
  quiz: any,
  mobileVersion: boolean,
  ABTest: boolean
): string | undefined {
  const values = [
    mobileVersion ? quiz?.mobileVersionQuiz?.textContactButton : undefined,
    ABTest ? quiz?.ABTestObj?.textContactButton : undefined,
    quiz?.textContactButton
  ];

  const versionedTextContactButton = values.find(isVersionedTextContactButton);

  if (versionedTextContactButton) {
    return normalizeTextContactButton(
      versionedTextContactButton,
      mobileVersion
    );
  }

  for (const value of values) {
    const normalizedValue = normalizeTextContactButton(value, mobileVersion);

    if (normalizedValue !== undefined) {
      return normalizedValue;
    }
  }

  return undefined;
}

function getTextContactButtonTarget(
  quiz: any,
  mobileVersion: boolean,
  ABTest: boolean
): {pc?: string; mobile?: string} | undefined {
  const values = [
    mobileVersion ? quiz?.mobileVersionQuiz?.textContactButton : undefined,
    ABTest ? quiz?.ABTestObj?.textContactButton : undefined,
    quiz?.textContactButton
  ];

  return values.find(isVersionedTextContactButton);
}

function copyIsOrigInAb(orig: any, obj: any): any {
  for (const key in orig) {
    const isArrayIndex = !isNaN(Number(key));
    if (Object.prototype.hasOwnProperty.call(orig, key)) {
      let newVale = orig[key];
      if (typeof newVale === "object" || Array.isArray(newVale)) {
        if (!obj[key]) {
          obj[key] = newVale;
        }
        if (!isArrayIndex) {
          newVale = copyIsOrigInAb(orig[key], obj[key]);
        }
      }
      if (!isArrayIndex && !obj[key]) {
        obj[key] = newVale;
      }
    }
  }
  return obj;
}

function imgFromQuestion(file: File): boolean {
  if (file.name.includes("variant") || file.name.includes("information")) {
    return true;
  }
  return false;
}

export async function saveImgQuiz(
  file: File,
  mobileVersion: boolean
): Promise<string> {
  const quizStore = useQuizStore();
  function considerVersion(version: boolean): boolean {
    return version && !imgFromQuestion(file);
  }

  const ABTest = localStorage.getItem("ABTest") === "true";
  let formData = new FormData();
  const originalQuiz = quizStore.getQuiz;
  let nameSplit = file.name.split(".");
  let type = nameSplit[nameSplit.length - 1];
  let blob = file.slice(0, file.size, file.type);

  let newName = nameSplit.slice(0, nameSplit.length - 1).join(".");
  if (considerVersion(mobileVersion)) {
    newName += `Mobile`;
  }
  if (considerVersion(ABTest)) {
    newName += `ABTest`;
  }
  newName += `.${type}`;

  let newFile = new File([blob], newName, {type: file.type});

  formData.append("file", newFile);
  formData.append("id", originalQuiz["_id"]);
  formData.append(
    "mobileVersion",
    considerVersion(mobileVersion) ? "true" : "false"
  );
  formData.append("ABTest", considerVersion(ABTest) ? "true" : "false");

  let path = "quiz/img";
  const queryParams: string[] = [];

  if (
    ["video/mp4", "image/svg+xml", "image/gif", "video/webm"].includes(
      newFile.type
    ) ||
    newName.includes("logo")
  ) {
    path += "/straightLoading";
    queryParams.push(
      `id=${encodeURIComponent(String(originalQuiz["_id"] || ""))}`
    );
  }
  if (considerVersion(mobileVersion)) {
    queryParams.push("mobileVersion=true");
  }
  if (considerVersion(ABTest)) {
    queryParams.push("ABTest=true");
  }
  if (queryParams.length > 0) {
    path += `?${queryParams.join("&")}`;
  }

  return await HTTP.post(path, formData, {
    timeout: MEDIA_UPLOAD_TIMEOUT_MS,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
    .then((result) => {
      return result.data;
    })
    .catch(() => {
      throw "Ошибка при загрузке картинки";
    });
}

export async function getBaseUrl(): Promise<string> {
  try {
    const domain = await API.getDomain();
    return normalizePublicQuizBaseUrl(domain);
  } catch {
    return normalizePublicQuizBaseUrl(BASEURL.replace("api", "quiz/"));
  }
}
